/* eslint-disable react/prop-types */
import FieldText from '@components/CustomFields/FieldText'
import FieldTextPassword from '@components/CustomFields/FieldTextPassword'
import { makeStyles, Typography } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    width: '90%',
    flexDirection: 'column',
    marginTop: 20,
    height: '100%',
    paddingBottom: 200,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
    },
  },
  txReceiver: {
    fontWeight: 'bold',
    fontSize: 20,
  },
  passwordContainer: {
    display: 'flex',
    alignItems: 'center',
    '&> *': {
      flex: '50%',
    },
  },
}))

const AffiliateForm = (props) => {
  const { register, isSubmitting, watch } = props
  const classes = useStyles()
  return (
    <div className={classes.form}>
      <Typography
        variant="h6"
        className={classes.txReceiver}
      >
        Data Affiliate
      </Typography>
      <FieldText
        name="name"
        label="Nama Lengkap"
        register={register}
        disabled={isSubmitting}
        watch={watch}
        {...props}
      />
      <FieldText
        name="phone"
        label="Nomor Hp/Whatsapp"
        register={register}
        disabled={isSubmitting}
        watch={watch}
        {...props}
      />
      <FieldText
        name="email"
        label="Email"
        register={register}
        disabled={isSubmitting}
        watch={watch}
        {...props}
      />
      <div className={classes.passwordContainer}>
        <FieldTextPassword
          name="password"
          label="Kata Sandi"
          register={register}
          isSubmitting={isSubmitting}
          {...props}
        />
        <FieldTextPassword
          name="password_confirmation"
          label="Konfirmasi Kata Sandi"
          register={register}
          isSubmitting={isSubmitting}
          {...props}
        />
      </div>
    </div>
  )
}
export default AffiliateForm
